import gql from 'graphql-tag';
import { SALES_REPORT_SELECTION } from '@/store/salesReportSelection';
import { REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS } from '@/store/reportTemplateImages';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';
import { PROJECT_SALES_REPORT_PHOTO_FIELDS } from './projectSalesReportFields';

const PHOTO_LIST_SELECTION = PROJECT_SALES_REPORT_PHOTO_FIELDS.map(
  (field) => `${field} { ${ATTACHMENT_FIELDS} }`
).join('\n');

/**
 * Data of the block project-sales-report-data ("Sales Protokoll: Erfasste Daten"): the cards
 * (`salesReport`), the photo lists of the cards and the template images of the cards. Read through
 * `Project.blocks.salesReportData`, which checks the block's read permission.
 */
export const PROJECT_SALES_REPORT_DATA_FIELDS = gql`
  fragment projectSalesReportDataFields on ProjectSalesReportDataBlock {
    id
    number
    salesReport {
      ${SALES_REPORT_SELECTION}
    }
    ${PHOTO_LIST_SELECTION}
    reportTemplateImages {
      ...reportTemplateImageFields
    }
  }
  ${REPORT_TEMPLATE_IMAGE_REQUEST_FIELDS}
`;
